import React from 'react';

const AdvancedEmailSearchForm = ({
  formData,
  setFormData,
  handleSearchEmails,
  loading,
  handleReset,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const SEARCHIN_FOLDER_OPTIONS = {
    allFolder: 'All Folders',
    inbox: 'Inbox',
    junkEmail: 'Junk Email',
    drafts: 'Drafts',
    sentItems: 'Sent Items',
    deletedItems: 'Deleted Items',
    archive: 'Archive',
    conversationHistory: 'Conversation History',
  };
  return (
    <section className="flex w-full items-center justify-center">
      <article className="w-full max-w-4xl rounded-b-lg border border-zinc-600 bg-zinc-800 p-4 shadow-lg">
        <form
          onSubmit={handleSubmit}
          onReset={handleReset}
          className="space-y-5 text-sm"
        >
          <div className="space-y-4">
            {[
              {
                label: 'Search in',
                name: 'searchIn',
                type: 'select',
                options: SEARCHIN_FOLDER_OPTIONS,
              },
              { label: 'From', name: 'from', type: 'email' },
              { label: 'To', name: 'to', type: 'email' },
              { label: 'CC', name: 'cc', type: 'email' },
              { label: 'Subject', name: 'subject', type: 'text' },
              { label: 'Keyword', name: 'keyword', type: 'text' },
            ].map(({ label, name, type, options }) => (
              <div key={name} className="flex flex-col gap-1">
                <label
                  htmlFor={name}
                  className="text-sm font-semibold text-zinc-400"
                >
                  {label}
                </label>
                {type === 'select' ? (
                  <select
                    id={name}
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    className="w-full rounded-lg border border-zinc-500 bg-zinc-700 px-2 py-1 text-zinc-200 transition-all focus:border-[#5652CF] focus:outline-none"
                  >
                    {Object.entries(options).map(([key, val]) => (
                      <option key={key} value={val}>
                        {val}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id={name}
                    name={name}
                    type={type}
                    value={formData[name]}
                    onChange={handleChange}
                    className="w-full rounded-lg border border-zinc-500 bg-zinc-700 px-2 py-1 text-zinc-200 transition-all focus:border-[#5652CF] focus:outline-none"
                  />
                )}
              </div>
            ))}
            <div className="flex flex-wrap gap-4">
              <div className="flex flex-col">
                <label
                  htmlFor="date-from"
                  className="text-sm font-semibold text-zinc-400"
                >
                  Date from
                </label>
                <input
                  type="date"
                  name="dateFrom"
                  id="date-from"
                  value={formData.dateFrom}
                  onChange={handleChange}
                  className="rounded-lg border border-zinc-500 bg-zinc-700 px-2 py-2 text-zinc-200 focus:border-[#5652CF] focus:outline-none"
                />
              </div>
              <div className="flex flex-col">
                <label
                  htmlFor="date-to"
                  className="text-sm font-semibold text-zinc-400"
                >
                  To
                </label>
                <input
                  type="date"
                  name="dateTo"
                  id="date-to"
                  value={formData.dateTo}
                  onChange={handleChange}
                  className="rounded-lg border border-zinc-500 bg-zinc-700 px-2 py-2 text-zinc-200 focus:border-[#5652CF] focus:outline-none"
                />
              </div>
            </div>
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <label
                  htmlFor="attachments"
                  className="text-sm font-semibold text-zinc-400"
                >
                  Attachments
                </label>
                <input
                  type="checkbox"
                  name="attachments"
                  id="attachments"
                  checked={formData.attachments}
                  onChange={handleChange}
                  className="h-3 w-3 text-[#5652CF]"
                />
              </div>

              <div className="flex gap-2">
                <button
                  onClick={handleSearchEmails}
                  disabled={loading}
                  type="submit"
                  className={`rounded-md bg-blue-600 px-2 py-1 font-semibold text-white transition-all ${loading ? 'animate-pulse' : 'hover:bg-blue-700'}`}
                >
                  {loading ? 'Searching...' : 'Search'}
                </button>
                <button
                  type="reset"
                  className="rounded-md bg-zinc-600 px-2 py-1 font-semibold text-white hover:bg-zinc-700"
                >
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </form>
      </article>
    </section>
  );
};

export default AdvancedEmailSearchForm;
